import {
  createDocumentList,
  ensureNumberedDocumentUid,
  getProjectDocumentList,
} from "../../../../../pages/client/AllEquipments/CommonFeatures/DCSTab/Table/Dashboard/docListAPI";
import { getAllData } from "../../../../../pages/client/Ams/PV3/api";
import { getDrawings } from "../../../../../pages/client/AllEquipments/CommonFeatures/MCS3/BOMTab/DrawingRegisterTab/api";

/**
 * Document Register rows, PV input revisions and MCS drawings behind
 * one WBS. Each function does its HTTP call(s) and returns data;
 * caching stays with the caller.
 */
export const fetchWbsDocuments = async (wbsId) => {
  const docs = await getProjectDocumentList("all", wbsId);
  return Array.isArray(docs) ? docs : [];
};

// Creates a new Document Register row under a WBS, auto-numbering
// its UID (e.g. COR-001) the same way the full Document Register editor
// does (see DOCUMENT_REGISTER_GUIDE.md).
export const createNumberedWbsDocument = async ({
  wbsId,
  plantName,
  wbsName,
  existingDocs,
  abbreviation,
  type,
  revision,
  description,
  numberOfSheets,
}) => {
  const numbered = ensureNumberedDocumentUid(
    { documentName: abbreviation },
    Array.isArray(existingDocs) ? existingDocs : [],
  );

  await createDocumentList(
    "all",
    wbsId,
    {
      ...numbered,
      type,
      revision,
      description,
      numberOfSheets,
      projectNumber: plantName,
    },
    { wbsLabel: wbsName },
  );
};

export const fetchPvInputData = async (wbsId) => getAllData(wbsId);

export const fetchWbsDrawings = async (wbsId) => {
  const drawings = await getDrawings(wbsId);
  return Array.isArray(drawings) ? drawings : [];
};
